import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tenants: [],
  loading: false,
  error: null
};

const tenantsSlice = createSlice({
  name: 'tenants',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.loading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Fetch tenants success
    fetchTenantsSuccess: (state, action) => {
      state.tenants = action.payload;
      state.loading = false;
    },
    // Onboard new tenant success
    onboardTenantSuccess: (state, action) => {
      state.tenants.push(action.payload);
      state.loading = false;
    },
    // Activate or deactivate tenant success
    updateTenantStatusSuccess: (state, action) => {
      const updatedTenant = action.payload;
      const index = state.tenants.findIndex(
        tenant => tenant.id === updatedTenant.id
      );
      if (index !== -1) {
        state.tenants[index] = updatedTenant;
      }
      state.loading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchTenantsSuccess,
  onboardTenantSuccess,
  updateTenantStatusSuccess
} = tenantsSlice.actions;

export default tenantsSlice.reducer;
